import { useEffect, useState } from 'react'
import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { useProperty } from '../../PropertyContext';
import { GetResCorporatedetail, ReservationBookinglist } from '../../Services/Service';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as XLSX from "xlsx";
import "./ReservationReportTheme.css";

export const ReserCorporateBookingReport = () => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [bookingData, setBookingData] = useState([]);
    const [corporateList, setCorporateList] = useState([]);
    const [filters, setFilters] = useState({
        CompName: "",
        CheckInDate: "",
        CheckOutDate: ""
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {

        const fetchBookings = async () => {
            if (!selectedProperty?.PropertyID) return;

            setLoading(true);
            try {
                const data = await ReservationBookinglist({
                    propertyID: selectedProperty.PropertyID,
                    CompName: filters.CompName,
                    CheckInDate: filters.CheckInDate,
                    CheckOutDate: filters.CheckOutDate,
                });

                setBookingData(data || []);
            } catch (error) {
                console.log("Error fetching bookings", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBookings();

    }, [selectedProperty, filters]);


    useEffect(() => {
        const FetchCorporateDetail = async () => {
            try {
                const result = await GetResCorporatedetail(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    const filtered = result.filter(
                        (corp) => corp.CorporateID && corp.TA_Name
                    );
                    setCorporateList(filtered);
                }
            } catch (error) {
                console.log("error get corporate detail", error);
            }
        };

        FetchCorporateDetail();
    }, [selectedProperty]);

    const exportCorporateToExcel = () => {
        if (!bookingData || bookingData.length === 0) return;

        try {
            setLoading(true);

            const formattedData = bookingData.map((item, index) => {
                let email = "N/A";
                let mobile = "N/A";

                try {
                    const gd = JSON.parse(item.GuestDetails);
                    email = gd?.[0]?.EMailAddress || "N/A";
                    mobile = gd?.[0]?.MobileNumber || "N/A";
                } catch { }

                return {
                    "Sr#": index + 1,
                    "BON REF. Id": item.BONRESID,
                    "Conf. No": item.PMSRESID,
                    "Check-in": item.CheckInDate,
                    "Check-out": item.CheckOutDate,
                    "Guest Name": item.GuestName,
                    "Company": item.CompanyName,
                    "Email": email,
                    "Mobile No": mobile,
                    "Total Payment": item.TotalPayment,
                    "Payment Status": item.PaymentStatus,
                    "Booking Status": item.BookingStatus,
                    "Booking Date": item.BookingDate
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Corporate Booking Report");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Corporate_Booking_Report.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Corporate Export Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner reservation-report-page">

                            <div className="row">
                                <div className="col-md-12">

                                    <div className='card booking-filter-form'>
                                        <div className='card-body'>

                                            <form>
                                                <div className='d-flex gap-3'>

                                                    {/* Company Name */}
                                                    <div>
                                                        <label className='form-label'>Corporate name</label>
                                                        <select
                                                            className='form-select form-control'
                                                            name="CompName"
                                                            value={filters.CompName}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {corporateList.map((corp) => (
                                                                <option key={corp.CorporateID} value={corp.TA_Name}>
                                                                    {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Check-In */}
                                                    <div>
                                                        <label className='form-label'>Check-In</label>
                                                        <input
                                                            className='form-control'
                                                            type='date'
                                                            name="CheckInDate"
                                                            value={filters.CheckInDate}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Check-Out */}
                                                    <div>
                                                        <label className='form-label'>Check-Out</label>
                                                        <input
                                                            className='form-control'
                                                            type='date'
                                                            name="CheckOutDate"
                                                            value={filters.CheckOutDate}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Clear Button */}
                                                    <div className='text-end' style={{ marginTop: "27px" }}>
                                                        <button
                                                            className='btn btn-danger'
                                                            type='button'
                                                            onClick={() =>
                                                                setFilters({
                                                                    CompName: "",
                                                                    CheckInDate: "",
                                                                    CheckOutDate: ""
                                                                })
                                                            }
                                                        >
                                                            Clear
                                                        </button>
                                                    </div>

                                                </div>
                                            </form>

                                        </div>
                                    </div>



                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h4 className="card-title">Corporate Booking Report</h4>
                                                <button className='btn btn-sm btn-primary' type="button" onClick={exportCorporateToExcel}>Export</button>
                                            </div>
                                        </div>

                                        <div className="card-body">
                                            <DataTable
                                                value={bookingData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                stripedRows
                                                showGridlines
                                                responsiveLayout="scroll"
                                                emptyMessage="No bookings found."
                                                filterDisplay="menu"
                                            >

                                                {/* Sr No */}
                                                <Column
                                                    header="Sr#"
                                                    body={(rowData, { rowIndex }) => rowIndex + 1}

                                                />

                                                {/* BON Ref Id */}
                                                <Column
                                                    field="BONRESID"
                                                    header="BON REF. Id"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search BON ID"
                                                />

                                                {/* Conf No */}
                                                <Column
                                                    field="PMSRESID"
                                                    header="Conf. No"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Conf No"
                                                />

                                                {/* Check In */}
                                                <Column
                                                    field="CheckInDate"
                                                    header="Check-in"
                                                    sortable
                                                    filter
                                                    dataType="date"
                                                />

                                                {/* Check Out */}
                                                <Column
                                                    field="CheckOutDate"
                                                    header="Check-out"
                                                    sortable
                                                    filter
                                                    dataType="date"
                                                />

                                                {/* Guest Name Filter */}
                                                <Column
                                                    field="GuestName"
                                                    header="Guest Name"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Guest"
                                                />

                                                {/* Mobile */}
                                                <Column
                                                    header="Mobile No"
                                                    filter
                                                    filterField="GuestDetails"
                                                    body={(rowData) => {
                                                        try {
                                                            const gd = JSON.parse(rowData.GuestDetails);
                                                            return gd?.[0]?.MobileNumber || "N/A";
                                                        } catch {
                                                            return "N/A";
                                                        }
                                                    }}
                                                />

                                                {/* Payment */}
                                                <Column
                                                    field="TotalPayment"
                                                    header="Payment"
                                                    sortable
                                                    filter
                                                    dataType="numeric"
                                                    body={(rowData) => (
                                                        <div>
                                                            <div>₹ {rowData.TotalPayment}</div>
                                                            <div
                                                                className={
                                                                    rowData.PaymentStatus === "Paid"
                                                                        ? "text-success"
                                                                        : rowData.PaymentStatus === "Pending"
                                                                            ? "text-warning"
                                                                            : "text-secondary"
                                                                }
                                                            >
                                                                {rowData.PaymentStatus || "N/A"}
                                                            </div>
                                                        </div>
                                                    )}
                                                />

                                                {/* Booking Status */}
                                                <Column
                                                    field="BookingStatus"
                                                    header="Status"
                                                    sortable
                                                    filter
                                                />

                                                {/* Booking Date */}
                                                <Column
                                                    field="BookingDate"
                                                    header="Book On"
                                                    sortable
                                                    filter
                                                    dataType="date"
                                                />

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
